import React from 'react';
import PlaceholderPage from './PlaceholderPage';

const PayablesPage: React.FC = () => (
  <PlaceholderPage
    title="代理应付"
    summary="代理对账单导入与应付核对入口将挂在本页（不新增代理管理菜单）。"
    designSection="应付管理 / kac-006"
  />
);

export default PayablesPage;
